import Base from "../../../base";
import Form from "../../../layout/form";
import ActivityService from "../../../../services/running/activity";

export default class ActivityEdit extends Base
{
    boot() {
        this.state = {
            model:{
                type:0,
                name:'',
                image:'',
                sort:0,
                content:'',
                status:1
            }
        }
    }

    service() {
        return ActivityService;
    }

    componentDidMount() {
        this.server.getDetail(this.getPropsParams('id'), data => {
            this.setModel(data);
        })
    }

    render() {
        return (
            <Form
                model={this.state.model}
                fields={{
                    name: '名称',
                    image:{name:'封面', type:'image'},
                    content:{name:'内容', type:'editor', height:'400px'},
                    sort:{name:'排序', type:'number'},
                    status:{name:'状态', type: 'radio', data: this.server.status}
                }}
            />
        );
    }
}
